module.exports = __webpack_public_path__ + "static/what-we-do-0661e2f239864f2e6a2d53cf15897e2b.png";